import React, { Component } from 'react'
import { object } from 'prop-types'
import { Fieldset } from 'react-gridforms'
import acc from 'accounting'

class Billing extends Component {

  render() {
    const { name } = this.props
    const header = this.props.data.get('header')
    const meta = this.props.data.get('meta')
    const misc = this.props.data.get('misc_billing')
    const reg = this.props.data.get('reg_billing')

    return (
      <div className="billing-fees row">
        <div className="misc col-print-6">
          <form className="grid-form">
            <Fieldset className="misc" legend="Miscellaneous Breakdown">
              <table className="table table-misc table-condensed">
                <thead>
                  <tr>
                    <th>Code</th>
                    <th>Name</th>
                    <th className="text-right">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {misc.map((m, k) => {
                    return (
                      <tr key={k}>
                        <td><small>{m.get('fee_code')}</small></td>
                        <td><small>{m.get('fee_name')}</small></td>
                        <td className="text-right"><small>{acc.formatNumber (m.get('amount'), 2)}</small></td>
                      </tr>
                    )
                  })}
                  <tr>
                    <th className="text-right" colSpan="2">Total Miscellaneous:</th>
                    <th className="text-right">{acc.formatNumber(meta.get('total_misc'), 2)}</th>
                  </tr>
                </tbody>
              </table>
            </Fieldset>
          </form>
        </div>
        <div className="ass col-print-6">
          <form className="grid-form">
            <Fieldset legend="Assessment of Fees">
              <table className="table table-condensed">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th className="text-right">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {reg.map((r, k) => {
                    return (
                      <tr key={k}>
                        <td>{r.get('fee_name')}</td>
                        <td className="text-right">{acc.formatNumber (r.get('amount'), 2)}</td>
                      </tr>
                    )
                  })}
                  <tr>
                    <td>Miscellaneous Fees</td>
                    <td className="text-right">{acc.formatNumber(meta.get('total_misc'), 2)}</td>
                  </tr>
                  <tr>
                    <th className="text-right">Total Billing:</th>
                    <th className="text-right">{acc.formatNumber(meta.get('total_amount'), 2)}</th>
                  </tr>
                </tbody>
              </table>
            </Fieldset>
          </form>
          <table width="100%">
            <tbody>
              <tr>
                <td width="40%"></td>
                <td>
                  <div className="sign">
                    <em><small>Certified by:</small></em> <strong>{name.get('full_name')}</strong><br />
                    <em><small>Designation:</small></em> Assessor<br />
                    <em><small>Date Printed:</small></em> {header.get('printed_date')}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

Billing.propTypes = {
  data: object,
  name: object,
}

export default Billing



// WEBPACK FOOTER //
// ./src/containers/Print/Billing/billing.js